<template>
  <div>
    <loadingPage v-show="isloading" />
    <div class="header">
      <img src="@/assets/icon/logo_flipaiot.png" class="logo" />
    </div>
    <div class="mainDiv">
      <div class="loginContainer">
        <div class="fromContainer">
          <div class="inputContainer">
            <img src="@/assets/icon/login/img_mail_icon.png" />
            <input
              type="email"
              id="emailInput"
              placeholder="Account (email)"
              autocomplete='off'
              v-model="userEmail"
              @focus="handleFocus"
              @blur="handleBlur"
            />
            <div class="suffix"></div>
            <div class="info">
              <span class="validText">{{ emailInfo }}</span>

              <label class="checkboxConatainer">
                <input
                  class="customCheckbox"
                  type="checkbox"
                  id="emailCache"
                  name="emailCache"
                  v-model="emailCache"
                />
                <span class="customLabel">Remember my account</span>
              </label>
              <!-- <label class="customLabel" for="emailCache">Remember my account</label> -->
            </div>
          </div>
          <div class="inputContainer">
            <img src="@/assets/icon/login/img_pwd_icon.png" />
            <input
              :type="pwdShowing ? 'text' : 'password'"
              id="pwdInput"
              placeholder="Password"
              v-model="userPassword"
              @focus="handleFocus"
              @blur="handleBlur"
            />
            <div class="suffix" @click="hideOrShowPassword">
              <img :src="require(`@/assets/icon/login/img_eye_${pwdShowing ?
              'open' : 'close'}.png`)" />
            </div>
            <div class="info">
              <span class="validText">{{ passwordInfo }}</span>
            </div>
          </div>
          <button class="loginBtn" :disabled="loginBtnEnable" @click="loginClick">Login</button>
        </div>
        <div class="helpfulLink">
          <p
            @click="linkClick">
            Forget the password? Get the password from Fliprobot.com by clicking the link.</p>
          <p
            @click="linkClick">
            Haven't signed up yet? Go to Fliprobot.com to sign up by clicking the link.</p>
        </div>
        <div class="ThirdPartyLogin">
          <div @click="fbLoginHandler">
            <img src="@/assets/icon/login/facebook_logo.png" alt="" />
            <span>Log in by Facebook account</span>
          </div>
          <div @click="googleLoginHandler">
            <img src="@/assets/icon/login/google_logo.png" alt="" />
            <span>Log in by Google account</span>
          </div>
        </div>

        <img class="fliprobotLogo" src="@/assets/icon/logo_fliprobot.png" alt="" />
      </div>
    </div>
    <div class="popupDiv" v-show="popupShow">
      <div class="popupContainer">
        <div class="popupHeader">
          {{ ErrorTitle }}
          <img src="@/assets/icon/notice_close@2x.png" />
        </div>
        <div class="popupBody">
          {{ ErrorMsg }}
        </div>
        <div class="popupFooter" @click="closePopup">OK</div>
      </div>
    </div>
  </div>
</template>

<script>
import loadingPage from '@/components/loadingPage.vue';

import { mapMutations } from 'vuex';

const linkURL = 'https://www.fliprobot.com.tw/login';

export default {
  components: {
    loadingPage,
  },
  data() {
    return {
      isloading: false,
      popupShow: false,
      userEmail: '',
      emailCache: false,
      userPassword: '',
      pwdShowing: false,
      emailInfo: '',
      passwordInfo: '',
      ErrorTitle: '',
      ErrorMsg: '',
      emailReg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      passwordReg: /[^a-zA-Z0-9_]/,
    };
  },
  created() {
    // 防止重複載入
    if (!window.FB) {
      window.fbAsyncInit = function () {
        // eslint-disable-next-line no-undef
        FB.init({
          appId: '2423999084577258', // 填入自己 app 的 id
          cookie: true,
          xfbml: true,
          version: 'v5.0', // 目前版本
        });
      };

      (function (d, s, id) {
        let js;
        const fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        // eslint-disable-next-line prefer-const
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    }
    if (!window.googleSDKLoaded) {
      window.googleSDKLoaded = () => {
        window.gapi.load('auth2', () => {
          window.gapi.auth2.init({
            client_id: '51403227179-sbt3asqhdgrgidffqi749ng9nrdr1d5n.apps.googleusercontent.com',
            cookiepolicy: 'single_host_origin',
          });
        });
      };
      (function (d, s, id) {
        let js;
        const fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        // eslint-disable-next-line prefer-const
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://apis.google.com/js/platform.js?onload=googleSDKLoaded';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'google-jssdk'));
    }
  },
  beforeMount() {
    console.log(this.$route.query.accessToken); // outputs 'yay'
    if (this.$route.query.accessToken) {
      this.$store.dispatch('refreshToken', { token: this.$route.query.accessToken })
        .then((res) => {
          console.log('go to chart');
          this.isloading = false;
          this.$router.replace({ path: 'chart' });
          return res;
        })
        .catch((err) => this.handleLoginError(err));
    }
  },
  mounted() {
    if (localStorage.getItem('userEmail')) {
      this.userEmail = localStorage.getItem('userEmail');
      this.setCacheEmail('');
      // this.emailCache = true;
    }
  },
  watch: {
    emailCache: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.setCacheEmail(this.userEmail);
        } else if (oldVal) {
          this.setCacheEmail('');
        }
      },
    },
    userEmail: {
      handler(newVal, oldVal) {
        if (newVal.length === 0 && oldVal.length > 0) {
          this.emailInfo = 'Please enter email address.';
        } else if (newVal.length > 0 && oldVal.length === 0) {
          this.emailInfo = '';
        }
      },
    },
    userPassword: {
      handler(newVal, oldVal) {
        if (newVal.length === 0 && oldVal.length > 0) {
          this.passwordInfo = 'Please enter passwords.';
        } else if (newVal.length > 0 && oldVal.length === 0) {
          this.passwordInfo = '';
        }
      },
    },
  },
  computed: {
    isEmailValid() {
      return this.emailReg.test(this.userEmail);
    },
    isPasswordValid() {
      return !this.passwordReg.test(this.userPassword);
    },
    loginBtnEnable() {
      if (this.isEmailValid && this.isPasswordValid
      && this.userPassword.length >= 8 && this.userPassword.length < 31) {
        return false;
      }
      return true;
    },
  },
  methods: {
    ...mapMutations(['setCacheEmail']),
    linkClick() {
      const win = window.open(linkURL, '_blank');
      win.focus();
    },
    handleBlur(e) {
      console.log(e.target.id);
      switch (e.target.id) {
        case 'emailInput':
          if (this.userEmail === '') {
            // no change
          } else if (!this.isEmailValid) {
            this.emailInfo = 'Format of the email address is incorrect.';
          } else {
            this.emailInfo = '';
          }
          break;
        case 'pwdInput':
          if (this.userPassword === '') {
            // no change
          } else if (!this.isPasswordValid) {
            this.passwordInfo = 'Only letters and numbers can be used.';
          } else if (this.userPassword.length < 8) {
            this.passwordInfo = 'At least 8 characters.';
          } else if (this.userPassword.length > 30) {
            this.passwordInfo = 'Less than 30 characters.';
          } else {
            this.passwordInfo = '';
          }
          break;
        default:
          break;
      }
    },
    handleFocus(e) {
      switch (e.target.id) {
        case 'emailInput':
          this.emailInfo = '';
          break;
        case 'pwdInput':
          this.passwordInfo = '';
          break;
        default:
          break;
      }
    },
    hideOrShowPassword() {
      this.pwdShowing = !this.pwdShowing;
    },
    closePopup() {
      this.popupShow = false;
      if (this.ErrorMsg === 'The account doesn’t have authentication to use FlipAIoT.') {
        const win = window.open('https://www.fliprobot.com.tw/user/cards', '_blank');
        win.focus();
      }
    },
    loginClick() {
      this.login({ info: { email: this.userEmail, password: this.userPassword } });
    },
    login(payload) {
      this.isloading = true;
      this.$store
        .dispatch('loginProcess', payload)
        // .dispatch('fakeLogin', payload)
        .then((res) => {
          console.log('go to chart');
          this.isloading = false;
          this.$router.replace({ path: 'chart' });
          return res;
        })
        .catch((err) => this.handleLoginError(err));
    },
    handleLoginError(err) {
      console.log(err);
      if (err.status === 403) {
        this.ErrorTitle = 'Permission Denied.';
        this.ErrorMsg = 'The account doesn’t have authentication to use FlipAIoT.';
      } else if (err.status === 401) {
        if (err.message.split('.')[1] === 'email') {
          this.ErrorTitle = 'Account Invalid';
          this.ErrorMsg = 'The account isn’t valid.';
        } else if (err.message.split('.')[1] === 'password') {
          this.ErrorTitle = 'Passwords Invalid';
          this.ErrorMsg = 'The password isn’t valid.';
        } else {
          this.ErrorTitle = 'Account Invalid';
          this.ErrorMsg = 'The account isn’t valid.';
        }
      } else {
        this.ErrorTitle = 'Errpr';
        this.ErrorMsg = err;
      }
      this.isloading = false;
      this.popupShow = true;
    },
    fbLoginHandler() {
      const vm = this;
      // 檢查登入狀態
      // eslint-disable-next-line no-undef
      FB.getLoginStatus((response) => {
        // 登入狀態 - 已登入
        if (response.status === 'connected') {
          // 獲取用戶個人資料
          vm.fbLogin();
        } else {
          // 登入狀態 - 未登入
          // 用戶登入(確認授權)
          // eslint-disable-next-line no-undef
          FB.login(
            (res) => {
              // 獲取用戶個人資料
              console.log(res);
              vm.fbLogin();
            },
            // 授權 - 個人資料&Email
            { scope: 'public_profile,email' },
          );
        }
      });
    },
    getProfile() {
      return new Promise((resolve) => {
        // eslint-disable-next-line no-undef
        FB.api('/me?fields=name,id,email', (res) => {
          // do something
          resolve(res);
          // console.log(res);
        });
      });
    },
    fbLogin() {
      this.getProfile()
        .then((res) => {
          console.log('FB login ------------');
          const userProfile = {
            email: res.email,
            uid: res.id,
            kind: 'facebook',
          };
          this.login({ info: userProfile, type: 'oauth' });
          // console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    googleLoginHandler() {
      this.googleLogin()
        .then((res) => {
          console.log('GOOGLE login ------------');
          this.login({ info: res, type: 'oauth' });
          // console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    googleLogin() {
      return new Promise((resolve, reject) => {
        const auth2 = window.gapi.auth2.getAuthInstance();
        auth2
          .signIn({ scope: 'profile email' })
          .then(() => {
            const profile = auth2.currentUser.get().getBasicProfile();
            resolve({
              email: profile.getEmail(),
              uid: profile.getId(),
              kind: 'google',
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.popupDiv {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  .popupContainer {
    width: 380px;
    height: 185px;
    background-color: #f3f5f9;
    border-radius: 10px;
    position: relative;
    .popupHeader {
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
      background-color: #ffffff;
      height: 35px;
      border-radius: 10px 10px 0 0;
      font-size: 13px;
      line-height: 35px;
      color: #282828;
      img {
        position: absolute;
        right: 8px;
        top: 8px;
        height: 16px;
        cursor: pointer;
      }
    }
    .popupBody {
      font-size: 14px;
      text-align: left;
      color: #282828;
      padding: 20px;
    }
    .popupFooter {
      width: 100%;
      height: 36px;
      background-color: #37ccda;
      font-size: 20px;
      color: #f3f5f9;
      line-height: 36px;
      cursor: pointer;
      position: absolute;
      bottom: 32px;
    }
  }
}
.header {
  height: 160px;
  width: 100vw;
  background-color: #3c3d3e;
  display: flex;
  border-bottom: 8px solid #920b0b;
  .logo {
    margin: auto;
  }
}
.mainDiv {
  position: absolute;
  top: 160px;
  width: 100vw;
  bottom: 0px;
  background-color: #f3f5f9;
  min-height: 500px;
  .loginContainer {
    align-items: center;
    flex-direction: column;
    display: flex;
    justify-content: space-around;
    max-height: 720px;
    height: 100%;
    .fromContainer {
      width: 380px;
      padding: 40px 0px 24px 0px;
      border-bottom: 1px solid #9b9c9e;

      input {
        outline: none;
        border: none;
        font-family: Arial;
        font-size: 20px;
        color: #9b9c9e;
        flex-grow: 1;
      }
      .inputContainer {
        position: relative;
        border-radius: 3px;
        height: 45px;
        border: solid 1px #c6c8cb;
        background-color: #ffffff;
        margin-bottom: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        &:focus-within {
          box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.16);
          border: solid 1px #23b6bc;
          background-color: #ffffff;
        }
        img {
          height: 15px;
          margin: 0px 10px 0px 20px;
        }
        .info {
          position: absolute;
          height: 40px;
          display: flex;
          align-items: center;
          width: 100%;
          top: 40px;
          .validText {
            padding-top: 7px;
            height: 40px;
            color: black;
            font-size: 14px;
            text-align: left;
            width: 177px;
            opacity: 0.6;
            color: #af2626;
          }
          .checkboxConatainer {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 26px;
            width: 197px;
            margin: 0;
            // input[type="checkbox"] {
            //   display: none;
            // }

            .customCheckbox {
              width: 20px;
              height: 20px;
              border: solid 1px #9b9c9e;
              background-color: #ffffff;
              margin-right: 5px;
            }
            .customLabel {
              font-size: 16px;
              color: #9b9c9e;
              height: 26px;
              line-height: 26px;
              margin: 0;
              cursor: pointer;
            }
          }
        }
        .suffix {
          flex-basis: 52px;
          img {
            height: 20px;
            cursor:pointer;
          }
        }
      }
      .loginBtn {
        width: 100%;
        height: 50px;
        opacity: 0.7;
        border-radius: 38px;
        background-color: #23b6bc;
        font-size: 20px;
        border: none;
        color: #f3f5f9;
      }
      .loginBtn:disabled {
        border: solid 1px #727374;
        background-color: #eaecef;
        color: #9b9c9e;
      }
    }
    .helpfulLink {
      padding-top: 18px;
      p {
        color: #727374;
        cursor: pointer;
        &:hover {
          color: #23b6bc;
        }
      }
    }
    .ThirdPartyLogin {
      div {
        img {
          height: 20px;
        }
        span {
          color: #727374;
          font-size: 1rem;
          padding: 0px 10px;
        }
        width: 380px;
        height: 45px;
        border-radius: 23px;
        border: solid 1px #c6c8cb;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        cursor: pointer;
        &:hover {
          box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.16);
          border: solid 1px #23b6bc;
          background-color: #ffffff;
        }
      }
    }
    .fliprobotLogo {
      height: 33px;
    }
  }
}
</style>
